'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.978 7.47a7.455 7.455 0 1 1-14.91 0 7.455 7.455 0 0 1 14.91 0",
    id: "empty-messenger_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M55 27.5C55 42.688 42.687 55 27.5 55S0 42.688 0 27.5 12.313 0 27.5 0 55 12.312 55 27.5",
    id: "empty-messenger_svg__c"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.838 7.411A7.4 7.4 0 1 1 .036 7.41a7.4 7.4 0 0 1 14.802.001",
    id: "empty-messenger_svg__e"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M53.894 26.957c0 14.877-12.06 26.939-26.938 26.939C12.077 53.896.017 41.834.017 26.957.017 12.08 12.077.017 26.956.017c14.878 0 26.938 12.062 26.938 26.94",
    id: "empty-messenger_svg__g"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(6 6)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "#B4CBEB",
    fillRule: "nonzero",
    cx: 146.5,
    cy: 144.5,
    r: 135.5
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M279.257 178.292h-99.886a5.337 5.337 0 0 1-5.205-4.118c.387.089.79.135 1.204.135h99.887c2.95 0 5.34-2.38 5.34-5.316V75.82h4.001v97.154c0 2.936-2.391 5.317-5.34 5.317",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M275.257 174.31H175.37c-2.95 0-5.34-2.38-5.34-5.317v-102.6c0-2.936 2.39-5.317 5.34-5.317h99.887c2.95 0 5.34 2.381 5.34 5.318v102.599c0 2.936-2.39 5.316-5.34 5.316",
    fill: "#FFF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M269.085 145.607h-87.542a3.645 3.645 0 0 1-3.655-3.637V87.466a3.645 3.645 0 0 1 3.655-3.638h87.542a3.646 3.646 0 0 1 3.654 3.638v54.504a3.646 3.646 0 0 1-3.654 3.637",
    fill: "#E5F0F8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M261.343 77.827h-57.936a.938.938 0 0 1-.94-.936v-4.61c0-.517.421-.936.94-.936h57.936c.52 0 .94.419.94.936v4.61c0 .517-.42.936-.94.936M241.83 159.558c.29 0 .526.234.526.523v4.426c0 .29-.235.523-.526.523h-21.084a.524.524 0 0 1-.525-.523v-4.426c0-.289.235-.523.525-.523h21.084Zm29.599 0c.308 0 .56.249.56.557v4.36c0 .306-.252.555-.56.555h-23.973a.558.558 0 0 1-.56-.556v-4.359c0-.308.25-.557.56-.557h23.973Zm-55.25 0c.38 0 .686.307.686.684v4.105a.684.684 0 0 1-.686.683h-36.494a.685.685 0 0 1-.687-.683v-4.105c0-.377.308-.684.687-.684h36.494Zm12.17-8.445c.438 0 .793.354.793.79v3.893c0 .436-.355.79-.794.79h-48.914a.792.792 0 0 1-.794-.79v-3.893c0-.436.355-.79.794-.79h48.914Zm28.57 0c.31 0 .562.25.562.559v4.354a.56.56 0 0 1-.562.56H232.73a.56.56 0 0 1-.562-.56v-4.354a.56.56 0 0 1 .562-.559h24.188Z",
    fill: "#87868F"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1098F3",
    fillRule: "nonzero",
    d: "m268.924 156.852-3.39-1.898-3.391 1.898v-7.594h6.781v7.594"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M194.445 73.416c0 4.066-3.31 7.361-7.395 7.361-4.084 0-7.396-3.295-7.396-7.361s3.312-7.362 7.396-7.362 7.395 3.296 7.395 7.362",
    fill: "#BFBEC8"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(180 66)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-messenger_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-messenger_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#1098F3",
    fillRule: "nonzero",
    xlinkHref: "#empty-messenger_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.911 20.326c-.03-.633-.31-6.22-.657-7.52-.306-1.15-1.539-1.411-2.337-1.388-.074-.015-.142-.045-.22-.045h-.904V10.31c.07.004.136.02.209.02a3.342 3.342 0 0 0 3.341-3.341c0-.866.004-1.506-.019-1.992.183-.204.303-.468.303-.764 0-.52-.35-.941-.821-1.086.124-.117.214-.247.214-.395 0-.404-.534-.728-1.201-.748-.492-.246-1.212-.406-2.026-.406-.98 0-1.828.229-2.296.566-.029-.004-.054-.017-.083-.017a.754.754 0 0 0-.754.754c0 .122.035.232.085.333a.924.924 0 0 0-.63.868v.355c0 .268.118.506.301.675V7.42a.71.71 0 0 0 .42.645l.005.007.001-.004.013.007c.196.567.537 1.06.983 1.442v1.857h-.76c-.072 0-.134.03-.203.041-.797.003-1.94.293-2.233 1.391-.347 1.3-.627 6.888-.658 7.52l.212.011-.022.364 1.136.068.023-.376.167.008c.077-1.604.217-3.858.37-5.452v5.408c0 .667.54 1.208 1.208 1.208h3.62c.666 0 1.207-.541 1.207-1.208v-6.49c.197 1.462.394 4.515.492 6.534l.166-.008.024.376 1.134-.068-.021-.364.211-.01",
    fill: "#FFF",
    mask: "url(#empty-messenger_svg__b)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(199 87)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-messenger_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-messenger_svg__c"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#1098F3",
    fillRule: "nonzero",
    xlinkHref: "#empty-messenger_svg__c"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M34.551 9.172c2.5 0 4.547 1.893 4.547 4.208v22.213c0 1.888 4.509 3.432 2.471 3.432h-7.018c-2.5 0-4.545-1.894-4.545-4.208V13.38c0-2.315 2.045-4.208 4.545-4.208Z",
    fill: "#754C24",
    mask: "url(#empty-messenger_svg__d)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M35.67 40.58c.386 0 .76.051 1.116.147 2.798.106 6.54 1.219 7.531 4.936.541 2.03 1.037 7.006 1.431 12.135l.105 1.4c.444 6.067.74 11.99.797 13.159l-5.377.262a572.077 572.077 0 0 0-.48-8.493l-.062-.954-.063-.954a333.811 333.811 0 0 0-.71-8.972v19.216a4.288 4.288 0 0 1-4.288 4.288H22.823a4.288 4.288 0 0 1-4.287-4.288V49.397c-.698 5.19-1.395 16.052-1.744 23.222l-5.377-.262c.057-1.168.353-7.092.797-13.159l.105-1.4c.394-5.129.89-10.106 1.431-12.135 1.047-3.924 5.16-4.945 7.99-4.943.347-.092.71-.14 1.085-.14H35.67Z",
    fill: "#666",
    mask: "url(#empty-messenger_svg__d)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M25.293 13.158c10.963 0 11.86-1.455 11.86 11.86 0 3.621-1.622 6.863-4.179 9.038v6.524h-6.939v-3.723c-.246.015-.493.022-.742.022-6.55 0-11.86-5.31-11.86-11.86l-.002-2.071v-1.124c.009-11.038.517-8.666 11.862-8.666Z",
    fill: "#F9D9AF",
    mask: "url(#empty-messenger_svg__d)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M32.474 19.327c.2 1.535-.434 3.668-.434 3.668s-.072-1.429-1.686-2.471c-1.365-.883-8.85-1.197-8.85-1.197h-3.313c-.813 0-1.56-.298-2.136-.79-1.202.83-2.266 1.994-2.628 3.88l-.03-.148-.034-.175c-.22-1.129-.94-4.947-.94-6.86a4.08 4.08 0 0 1 1.2-2.894 3.887 3.887 0 0 1-.017-.35c0-3.603 5.565-6.525 12.43-6.525 6.863 0 12.428 2.922 12.428 6.525 0 .254-.028.504-.081.75.44.56.705 1.267.705 2.031v1.261a3.3 3.3 0 0 1-1.557 2.796l.49 7.506-1.51 2.525-.873-2.55s1.158-.643.99-2.909c-.168-2.266-2.334-.567-2.334-.567l-1.7-3.506Z",
    fill: "#754C24",
    mask: "url(#empty-messenger_svg__d)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    mask: "url(#empty-messenger_svg__d)",
    d: "M30.325 63.29h-2.156l-4.71-22.71h11.576l-4.71 22.71"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M30.55 41.253v1.738h-.742l1.363 16-.63 4.314h-2.636l-.79-4.05L28.67 42.99h-.725v-1.738h2.605Z",
    fill: "#001529",
    mask: "url(#empty-messenger_svg__d)"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M118.349 247.954H18.396a5.338 5.338 0 0 1-5.208-4.108c.387.09.79.136 1.205.136h99.953c2.951 0 5.344-2.374 5.344-5.303V153.82h4.003v88.83c0 2.93-2.393 5.304-5.344 5.304",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M114.346 243.982H14.393c-2.952 0-5.344-2.374-5.344-5.303V136.344c0-2.928 2.392-5.303 5.344-5.303h99.953c2.951 0 5.344 2.375 5.344 5.303V238.68c0 2.929-2.393 5.303-5.344 5.303",
    fill: "#FFF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M108.17 215.354H20.568c-2.02 0-3.656-1.625-3.656-3.628v-54.363c0-2.004 1.637-3.628 3.656-3.628h87.6c2.02 0 3.657 1.624 3.657 3.628v54.363c0 2.003-1.637 3.628-3.657 3.628",
    fill: "#E5F0F8"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M80.897 229.268c.29 0 .525.234.525.522v4.415a.524.524 0 0 1-.525.522H59.798a.524.524 0 0 1-.526-.522v-4.415c0-.288.236-.522.526-.522h21.099Zm29.617 0c.31 0 .56.249.56.555v4.348c0 .307-.25.556-.56.556H86.525a.558.558 0 0 1-.56-.556v-4.348c0-.306.251-.555.56-.555h23.99Zm-55.286 0c.38 0 .687.306.687.682v4.094a.685.685 0 0 1-.687.683H18.71a.685.685 0 0 1-.688-.683v-4.094c0-.376.308-.682.688-.682h36.517Zm12.178-8.423a.79.79 0 0 1 .794.788v3.882a.79.79 0 0 1-.794.789H18.458a.792.792 0 0 1-.794-.789v-3.882c0-.435.356-.788.794-.788h48.948Zm28.59 0c.31 0 .561.25.561.558v4.343a.56.56 0 0 1-.561.558H71.792a.56.56 0 0 1-.563-.558v-4.343a.56.56 0 0 1 .563-.558h24.204Zm4.426-79.561c.52 0 .941.417.941.933v4.599a.937.937 0 0 1-.941.933H42.448a.936.936 0 0 1-.94-.933v-4.599c0-.516.42-.933.94-.933h57.974Z",
    fill: "#87868F"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FBCB2F",
    fillRule: "nonzero",
    d: "m108.009 226.57-3.393-1.895-3.393 1.895v-7.575h6.786v7.575"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(19 136)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-messenger_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-messenger_svg__e"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#FBCB2F",
    fillRule: "nonzero",
    xlinkHref: "#empty-messenger_svg__e"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M11.794 20.172c-.03-.628-.309-6.175-.653-7.465-.304-1.14-1.527-1.4-2.32-1.377-.073-.015-.14-.045-.218-.045h-.898V10.23c.07.004.136.02.207.02a3.317 3.317 0 0 0 3.317-3.317c0-.86.004-1.495-.019-1.978.183-.202.301-.464.301-.757 0-.516-.347-.936-.814-1.08.122-.115.211-.244.211-.392 0-.4-.53-.722-1.191-.741-.488-.245-1.204-.403-2.012-.403-.972 0-1.814.226-2.279.56-.028-.002-.053-.015-.082-.015a.75.75 0 0 0-.749.749c0 .12.035.23.086.33a.916.916 0 0 0-.627.861v.353c0 .266.118.501.299.67v2.27c0 .284.173.528.417.64l.005.007.001-.004.014.007c.194.563.531 1.052.974 1.431v1.844h-.753c-.072 0-.134.028-.202.04-.79.004-1.926.291-2.217 1.382-.344 1.29-.622 6.837-.652 7.465l.21.01-.022.361 1.127.068.023-.374.165.008c.078-1.591.217-3.83.368-5.412v5.369a1.2 1.2 0 0 0 1.2 1.199h3.592a1.2 1.2 0 0 0 1.2-1.2v-6.443c.195 1.453.39 4.483.486 6.487l.166-.008.023.374 1.127-.068-.022-.36.21-.011",
    fill: "#FFF",
    mask: "url(#empty-messenger_svg__f)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(37 158)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-messenger_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-messenger_svg__g"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#F46364",
    xlinkHref: "#empty-messenger_svg__g"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M53.894 26.957c0 14.877-12.06 26.939-26.938 26.939C12.077 53.896.017 41.834.017 26.957.017 12.08 12.077.017 26.956.017c14.878 0 26.938 12.062 26.938 26.94",
    fill: "#FBCB2F",
    fillRule: "nonzero",
    mask: "url(#empty-messenger_svg__h)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M31.2 41.06c.38 0 .75.049 1.102.14 2.882 0 7.07 1.039 8.136 5.034.528 1.978 1.012 6.703 1.405 11.681l.072.936c.5 6.563.837 13.295.899 14.56l-5.475.265c-.144-2.96-.346-6.54-.583-10.102l-.066-.97c-.334-4.88-.73-9.615-1.126-12.56v23.473a4.365 4.365 0 0 1-4.364 4.365H18.12a4.365 4.365 0 0 1-4.364-4.365v-19.56c-.244 2.55-.48 5.57-.69 8.646l-.065.97c-.238 3.563-.44 7.143-.584 10.103l-5.474-.266c.061-1.264.398-7.996.898-14.559l.072-.936c.393-4.978.878-9.703 1.405-11.68 1.008-3.784 4.818-4.917 7.667-5.025.362-.098.743-.15 1.136-.15Z",
    fill: "#666",
    mask: "url(#empty-messenger_svg__h)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M28.685 13.143c11.55 0 12.067-2.415 12.076 8.823v1.144l-.001 1.234v.874c0 6.668-5.407 12.074-12.075 12.074-.254 0-.506-.007-.756-.023v3.791h-7.064v-6.642a12.048 12.048 0 0 1-4.254-9.2c0-13.556.913-12.075 12.074-12.075Z",
    fill: "#F9D9AF",
    mask: "url(#empty-messenger_svg__h)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.93 5.737c2.93 0 5.558.56 7.335 1.444 2.41.07 4.327 1.263 4.327 2.723 0 .513-.237.993-.649 1.403a4.165 4.165 0 0 1-1.323 8.116 4.18 4.18 0 0 1-.901-.097 3.331 3.331 0 0 1-.803.097H21.252l-1.73 3.57s-2.205-1.73-2.376.577c-.171 2.307 1.007 2.961 1.007 2.961l-.89 2.596-1.535-2.57.497-7.643a3.36 3.36 0 0 1-1.583-2.845v-1.284c0-1.454.937-2.7 2.236-3.162a2.726 2.726 0 0 1 2.772-3.885c1.7-1.2 4.772-2 8.28-2Z",
    fill: "#333",
    mask: "url(#empty-messenger_svg__h)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#FFF",
    mask: "url(#empty-messenger_svg__h)",
    d: "M23.562 64.18h2.196l4.795-23.12H18.767l4.795 23.12"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M25.986 41.745v1.77h-.739l1.583 16.557-.804 4.123h-2.684l-.64-4.393 1.386-16.288h-.754v-1.769h2.652Z",
    fill: "#001529",
    mask: "url(#empty-messenger_svg__h)"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M124.72 116.833c7.444 0 13.534 6.085 13.534 13.523v15.227c0 7.438-6.09 13.522-13.534 13.522h-13.297l-6.656 11.57c-.718 1.248-2.172 1.256-2.904.061l-.079-.137-6.063-11.494h-.069c-7.443 0-13.533-6.084-13.533-13.522v-15.227c0-7.438 6.09-13.523 13.533-13.523h29.068Z",
    fill: "#FBCB2F"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M115.946 144.394a1.901 1.901 0 1 1 0 3.801H94.912a1.901 1.901 0 1 1 0-3.801h21.034Zm11.39 0a1.901 1.901 0 1 1 0 3.801h-5.088a1.902 1.902 0 1 1 0-3.801h5.088Zm0-8.346a1.901 1.901 0 1 1 0 3.8h-21.034a1.901 1.901 0 1 1 0-3.8h21.034Zm-27.337 0a1.901 1.901 0 1 1 0 3.8h-5.087a1.901 1.901 0 1 1 0-3.8h5.087Zm27.337-8.507a1.901 1.901 0 1 1 0 3.8H94.912a1.901 1.901 0 1 1 0-3.8h32.424Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M247.349 255.846h-60.926c-6.967 0-12.668-5.697-12.668-12.658v-16.956c0-6.962 5.7-12.658 12.668-12.658h60.926c6.967 0 12.668 5.696 12.668 12.658v16.956c0 6.961-5.7 12.658-12.668 12.658",
    fill: "#1098F3"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M224.339 241.135a1.901 1.901 0 1 1 0 3.8h-36.274a1.901 1.901 0 1 1 0-3.8h36.274Zm23.243 0a1.901 1.901 0 1 1 0 3.8h-16.94a1.901 1.901 0 1 1 0-3.8h16.94Zm0-8.347a1.901 1.901 0 1 1 0 3.801h-32.887a1.901 1.901 0 1 1 0-3.8h32.887Zm-39.19 0a1.901 1.901 0 1 1 0 3.801h-20.327a1.901 1.901 0 1 1 0-3.8h20.327Zm39.19-8.506a1.901 1.901 0 1 1 0 3.8h-59.517a1.901 1.901 0 1 1 0-3.8h59.517Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M73.629 86.705H12.704C5.736 86.705.035 81.01.035 74.047V57.091c0-6.961 5.701-12.658 12.669-12.658h60.925c6.967 0 12.668 5.697 12.668 12.658v16.956c0 6.963-5.7 12.658-12.668 12.658",
    fill: "#FBCB2F"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M50.619 71.994a1.901 1.901 0 1 1 0 3.8H14.346a1.9 1.9 0 1 1 0-3.8h36.273Zm23.243 0a1.901 1.901 0 1 1 0 3.8h-16.94a1.9 1.9 0 1 1 0-3.8h16.94Zm0-8.346a1.901 1.901 0 1 1 0 3.8H40.975c-1.05 0-1.902-.85-1.902-1.9 0-1.05.852-1.9 1.902-1.9h32.887Zm-39.19 0a1.901 1.901 0 1 1 0 3.8H14.347a1.901 1.901 0 1 1 0-3.8h20.327Zm39.19-8.507a1.901 1.901 0 1 1 0 3.8H14.346a1.901 1.901 0 1 1 0-3.8h59.516Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M211.253.57c7.443 0 13.533 6.086 13.533 13.523V29.32c0 7.437-6.09 13.523-13.533 13.523h-13.298l-6.655 11.57c-.718 1.247-2.172 1.256-2.905.06l-.078-.137-6.064-11.494h-.067c-7.443 0-13.534-6.085-13.534-13.522V14.093c0-7.437 6.09-13.523 13.534-13.523h29.067Z",
    fill: "#1098F3"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M202.479 28.131a1.901 1.901 0 1 1 0 3.801h-21.035a1.901 1.901 0 1 1 0-3.8h21.035Zm11.39 0a1.901 1.901 0 1 1 0 3.801h-5.087a1.901 1.901 0 1 1 0-3.8h5.087Zm0-8.346a1.901 1.901 0 1 1 0 3.8h-21.034a1.901 1.901 0 1 1 0-3.8h21.034Zm-27.337 0a1.901 1.901 0 1 1 0 3.8h-5.088a1.901 1.901 0 1 1 0-3.8h5.088Zm27.337-8.507a1.901 1.901 0 1 1 0 3.801h-32.425a1.901 1.901 0 1 1 0-3.8h32.425Z",
    fill: "#3F3E4B"
  }))));
});
var EmptyMessenger = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.EmptyMessenger = EmptyMessenger;